<template>
    <base-modal class="confirm-modal"
                :title="title || __('modal/confirm_title')"
                :body="text || __('modal/confirm_text')"
                :actions="actions"
                :loading="loading"
    />
</template>

<script>
    export default {
        props: {
            title: {type: String, default: null},
            text: {type: String, default: null},
            btnConfirm: {type: String, default: null},
            btnCancel: {type: String, default: null},
            action: {type: [String, Function], default: null},
            payload: {required: false},
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            actions() {
                return [
                    {
                        label: this.btnCancel || this.__('modal/cancel'),
                        theme: 'light',
                        action: () => this.$emit('close'),
                    },
                    {
                        label: this.btnConfirm || this.__('modal/confirm'),
                        theme: 'primary',
                        action: this.confirm,
                    },
                ];
            },
        },

        methods: {
            async confirm() {
                this.loading = true;

                if (typeof this.action === "string") {
                    await this.$store.dispatch(this.action, this.payload);
                } else if (this.action instanceof Function) {
                    await this.action(this.payload);
                }

                this.$emit('confirm', this.payload);
                this.$emit('close');
            },
        },
    };
</script>